import * as React from "react";
import { forwardRef } from "react";
const SvgIcDashboard = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 17, viewBox: "0 0 20 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 17V11H12V17H17V9H20L10 0L0 9H3V17H8Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcDashboard);
export { ForwardRef as ReactComponent };
